<template>
    <div>
        <el-table :data="data" key="pj-main-table" row-key="vdR_SNO" border v-loading="isLoading" empty-text="無資料" :default-sort="{ prop: 'amt', order: 'descending' }">
            <el-table-column prop="index" label="名次" width="75" fixed key="pj_index" sortable> </el-table-column>
            <el-table-column type="expand" fixed key="pj_expend">
                <template slot-scope="props">
                    <el-table
                        size="mini"
                        :data="props.row.projects"
                        style="width: 100%"
                        class="ah-el-data-table inner-project-list-table"
                        border
                        v-loading="isLoading"
                        empty-text="沒有資料"
                        :key="'inner-project-list-' + props.row.vdR_SNO"
                    >
                        <el-table-column prop="payoo" label="系統編號" width="100">
                            <template slot-scope="scope">
                                <span class="idx" @click="onProjectClick(scope.row.sno)" @keydown="() => {}">{{ scope.row.poo }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="nam" label="專案名稱" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <div :class="{ projectName: true }">
                                    <span class="type-tag">{{ scope.row.pjcaT_NAM }}</span>
                                    <span class="name" @click="onProjectClick(scope.row.sno)" @keydown="() => {}">{{ scope.row.nam }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="分期 / 已開發票" width="120" align="center">
                            <template slot-scope="scope">
                                <div>
                                    <span :class="{ 'installments-count': true }">
                                        <span>{{ scope.row.installmentCount }}</span>
                                        <span>/</span>
                                        <span>{{ scope.row.installmentInvoicedCount }}</span>
                                    </span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="stF_NAM" label="專案經理" align="center" width="100"></el-table-column>
                        <el-table-column prop="projectAuditorName" label="專案經辦人" align="center" width="100">
                            <template slot-scope="scope">
                                <div class="">{{ scope.row.projectAuditorName ? scope.row.projectAuditorName : '無' }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="amt" label="專案總價" align="right" width="100">
                            <template slot-scope="scope">
                                <Money :v="scope.row.amt" />
                                <ahTip v-if="scope.row.cny != 'TWD'">
                                    約當台幣：
                                    <Money :v="scope.row.amt * getCnyRat(scope.row.cny)" round />
                                </ahTip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="thisYearAmt" label="當年度發票開立小計" align="right" width="100">
                            <template slot-scope="scope">
                                <Money :v="scope.row.thisYearAmt" />
                                <ahTip v-if="scope.row.cny != 'TWD'">
                                    約當台幣：
                                    <Money :v="scope.row.thisYearAmt * getCnyRat(scope.row.cny)" round />
                                </ahTip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cny" label="幣別" width="65"></el-table-column>
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column prop="fnam" label="客戶名稱" fixed key="pj_fnam">
                <template slot-scope="scope">
                    <span style="font-weight: bold">{{ scope.row.fnam }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="percent" label="佔年度專案總額 %" align="right" sortable key="percent">
                <template slot-scope="scope"> {{ scope.row.percent }} % </template>
            </el-table-column>
            <el-table-column prop="pjLength" label="有開發票的專案數" align="right" width="170" key="pj_pjT_CNT" sortable />
            <el-table-column prop="installmentInvoicedCount" label="已開發票數" width="130" align="right" key="installmentInvoicedCount" sortable />
            <el-table-column prop="amt" label="當年度發票開立總額" align="right" key="amt" sortable>
                <template slot-scope="scope">
                    <Money :v="scope.row.amt" round />
                </template>
            </el-table-column>
            <el-table-column prop="" label="幣別" width="80" align="center" key="pj_cny">
                <template slot-scope=""> TWD </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        isLoading: Boolean,
    },
    methods: {
        onProjectClick(sno) {
            this.$emit('project-click', sno);
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
    },
};
</script>
